import { Component, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { GoToStep } from '../../../../store/onboarding/onboarding.actions';
import { OnboardingSteps } from '../../../../store/onboarding/onboarding.model';
import { Router } from '@angular/router';
import { NavigateToDashboardFromSignUpComplete } from '../../../../store/app/app.actions';
import { ProfileDropdownComponent } from '../../../../shared/components/profile-dropdown/profile-dropdown.component';
import { PlatformLocation } from '@angular/common';

@Component({
  selector: 'app-verify-business',
  imports: [ProfileDropdownComponent],
  templateUrl: './verify-business.component.html',
})
export class VerifyBusinessComponent {
  readonly store = inject(Store);
  readonly router = inject(Router);
  readonly location = inject(PlatformLocation);

  constructor() {
    this.store.dispatch(new GoToStep(OnboardingSteps.FINAL));
    this.location.onPopState(() => {
      // block user from going back to upload screen.
      history.pushState(null, '', globalThis.location.href);
      this.toDashboard();
    });
  }

  toDashboard() {
    this.store
      .dispatch(new NavigateToDashboardFromSignUpComplete())
      .subscribe(() => this.router.navigate(['/dashboard']));
  }
}
